import { Component, Input, OnInit } from '@angular/core'
import { AlarmAppInstallModalComponent } from 'src/app/common/modals/alarm-app-install-modal/alarm-app-install-modal.component'
import { DailyLogReaction } from 'src/app/interfaces/daily-log'
import { ModalService } from 'src/app/services/modal/modal.service'

@Component({
  selector: 'app-daily-log-reaction-detail-modal',
  templateUrl: './daily-log-reaction-detail-modal.component.html',
  styleUrls: ['./daily-log-reaction-detail-modal.component.scss'],
})
export class DailyLogReactionDetailModalComponent implements OnInit {
  constructor(private modalService: ModalService) {}

  @Input() isHost!: boolean
  @Input() reaction!: DailyLogReaction

  ngOnInit() {}

  onClickConfirm(): void {
    this.modalService.dismiss()
  }

  async onClickAddComment(): Promise<void> {
    const modalData = {
      title: '타입스 앱을 설치해주세요',
      description: '타입스 앱을 설치하고 타입스의 모든 기능을 이용해 보세요',
      buttonText: '타입스 앱 설치하기',
    }
    const dialog = await this.modalService.openDialog(
      AlarmAppInstallModalComponent,
      modalData,
      'custom-center-round-modal'
    )
    await dialog.present()
  }
}
